import InProcessBuild from "../../../../components/InProcessBuild";
import ConfigObject from "./SettingAIMode/ConfigObject";
import ConfigValue from "./SettingAIMode/ConfigValue";
import ConfigZone from "./SettingAIMode/ConfigZone";
import i18n from "../../../../i18n";
import ConfigZoneCamUniview from "./SettingAIMode/ConfigZoneCamUniview";
import ConfigObjectCamUni from "./SettingAIMode/ConfigObjectCamUni";
import ConfigPositionCarPark from "./SettingAIMode/ConfigPositionCarPark";
import ConfigFollowLicensePlace from "./SettingAIMode/ConfigWatchlistLisencePlace";
const { t } = i18n;
export const source = [
  {
    label: "Nguồn phụ",
    value: "SUB",
  },
  {
    label: "Nguồn chính",
    value: "MAIN",
  },
];

export const lReSo = {
  data: [{ QUALITY: "360p" }, { QUALITY: "480p" }, { QUALITY: "720p" }],
};

export const MotionConfig = [
  {
    tabIndex: 0,
    tabName: t("setting.Processing_parameters"),
    component: <ConfigValue />,
  },
  {
    tabIndex: 1,
    tabName: t("setting.Surveillance_area"),
    component: <ConfigZone />,
  },
];
export const FireDetectConfig = [
  {
    tabIndex: 0,
    tabName: t("setting.Processing_parameters"),
    component: <ConfigValue />,
  },
  {
    tabIndex: 1,
    tabName: t("setting.Unsupervised_area"),
    component: <ConfigZone />,
  },
];
export const CommonConfig = [
  {
    tabIndex: 0,
    tabName: t("setting.Processing_parameters"),
    component: <ConfigValue />,
    // component: <InProcessBuild />
  },
  {
    tabIndex: 1,
    tabName: t("setting.Select_object"),
    component: <ConfigObject />,
    // component: <InProcessBuild />
  },
  {
    tabIndex: 2,
    tabName: t("setting.Surveillance_area"),
    component: <ConfigZone />,
    // component: <InProcessBuild />
  },
];
export const CameraMoveConfig = [
  {
    tabIndex: 0,
    tabName: t("setting.Processing_parameters"),
    component: <ConfigValue />,
  },
  // {
  //   tabIndex: 1,
  //   tabName: t("setting.Surveillance_area"),
  //   component: <ConfigZone />
  // },
];

export const LisencePlateConfig = [
  {
    tabIndex: 0,
    tabName: t("setting.Processing_parameters"),
    component: <ConfigValue />,
    // component: <InProcessBuild />
  },
  {
    tabIndex: 1,
    tabName: t("setting.Surveillance_area"),
    component: <ConfigZone />,
    // component: <InProcessBuild />
  },
  {
    tabIndex: 2,
    tabName: t("setting.Select_object"),
    component: <ConfigObject />,
    // component: <InProcessBuild />
  },
  {
    tabIndex: 3,
    tabName: t("setting.Watchlist"),
    component: <ConfigFollowLicensePlace />,
    // component: <InProcessBuild />
  },
];

export const LisencePlateConfigUni = [
  {
    tabIndex: 0,
    tabName: t("setting.Processing_parameters"),
    component: <ConfigValue />,
    // component: <InProcessBuild />
  },
  {
    tabIndex: 1,
    tabName: t("setting.Surveillance_area"),
    component: <ConfigZoneCamUniview />,
    // component: <InProcessBuild />
  },
  {
    tabIndex: 2,
    tabName: t("setting.Select_object"),
    component: <ConfigObjectCamUni />,
    // component: <InProcessBuild />
  },
  {
    tabIndex: 3,
    tabName: t("setting.Watchlist"),
    component: <ConfigFollowLicensePlace />,
    // component: <InProcessBuild />
  },
];

export const ObjectLisencePlate = {
  data: [
    {
      CODE: 3,
      CODE_SYSTEM: "car",
      NAME_VN: "Xe hơi",
      PRIORITY: 1,
    },
    {
      CODE: 4,
      CODE_SYSTEM: "motorcycle",
      NAME_VN: "Xe máy",
      PRIORITY: 1,
    },
    {
      CODE: 6,
      CODE_SYSTEM: "bus",
      NAME_VN: "Xe buýt",
      PRIORITY: 1,
    },
    {
      CODE: 8,
      CODE_SYSTEM: "truck",
      NAME_VN: "Xe tải",
      PRIORITY: 1,
    },
  ],
};

export const streamMode = [
  // {
  //     label: 'h265',
  //     value: 'h265',
  // },
  {
    label: "h264",
    value: "h264",
  },
  {
    label: "copy",
    value: "copy",
  },
];
export const protocol = [{
  label:"Tiêu chuẩn",
  value:"hls"
},
{
  label:"Nâng cao",
  value:"webrtc"
}]
export const defaultValueRegionAPLRUniview = {
  trigger_line: [
    {
      LineID: 1,
      Enabled: 1,
      LineType: 1,
      LineLocation: {
        Head: {
          X: 449,
          Y: 8199
        },
        Tail: {
          X: 9549,
          Y: 8199
        }
      }
    }
  ],
  lanes_line: [
    {
      LineID: 1,
      Enabled: 1,
      LineLocation: {
        Head: {
          X: 832,
          Y: 6665
        },
        Tail: {
          X: 0,
          Y: 9999
        }
      }
    },
    {
      LineID: 2,
      Enabled: 1,
      LineLocation: {
        Head: {
          X: 9165,
          Y: 6665
        },
        Tail: {
          X: 9999,
          Y: 9999
        }
      }
    }
  ]
}

export const laneLineUniViewAlpr = {
  Enabled: 1,
  LineLocation: {
    Head: {
      X: 2500,
      Y: 6665
    },
    Tail: {
      X: 2500,
      Y: 9999
    }
  }
}

export const objectCamUniALPR = [
  {
    label: 'Xe cơ giới',
    key: "motor_vehicle",
  },
  {
    label: 'Xe gắn máy',
    key: "motorcycle",
  },
  {
    label: 'Xe không động cơ',
    key: "non_motor",
  },
  {
    label: 'Người đi bộ',
    key: "pedestrian",
  },
]

export const CarPark = [
  {
    tabIndex: 0,
    tabName: t("setting.Processing_parameters"),
    component: <ConfigValue />,
  },
  {
    tabIndex: 1,
    tabName: t("setting.Surveillance_area"),
    component: <ConfigPositionCarPark />,
  },
];


export const objectType = [
  { label: 'Ô tô', value: 'car' },
  { label: 'Xe Máy', value: 'motorcycle' },
]